import { Box, MenuItem } from '@chakra-ui/react'

interface FloorDropdownItemIProps {
  title: string
  selected: boolean
  onClick: () => void
}

export const FloorDropdownItem = ({
  title,
  selected,
  onClick,
}: FloorDropdownItemIProps) => {
  return (
    <MenuItem
      _hover={{ bg: !selected ? '#F7F8F9' : '#6096F5' }}
      bg={selected ? '#6096F5' : '#fff'}
    >
      <Box
        color={selected ? '#fff' : '#282424'}
        cursor='pointer'
        fontSize='18px'
        fontWeight='medium'
        onClick={onClick}
        overflow='hidden'
        pos='relative'
        textAlign='center'
        w='100%'
      >
        {title}
      </Box>
    </MenuItem>
  )
}
